import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button'
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';

const getCaret = direction => {
    if (direction === 'asc') {
        return (
            <span> <i className="fa fa-sort-asc" aria-hidden="true" /></span>
        );
    }

    if (direction === 'desc') {
        return (
            <span> <i className="fa fa-sort-desc" aria-hidden="true" /></span>
        );
    }

    return (
        <span> <i className="fa fa-sort" aria-hidden="true" /></span>
    );
};

const nomeFormatter = (cell, row) => {
    return `${row.nome + " " + row.apelido}`;
};

const actionsFormatter = (cell, row, obj) => {
    let acoes = <div>
        <Button title="Editar" size="sm" className="bg-info" href={`/editar-agricultor/${row.id}`}> <span className="fa fa-pencil" /> </Button>
        &nbsp;
                </div>
    return acoes;
};
const columns = [{
    dataField: 'nome_completo',
    text: 'Nome',
    sort: true,
    filter: textFilter({
        placeholder: 'Consultar',  // custom the input placeholder
    })
}, 
{
    dataField: 'telefone',
    text: 'Telefone',
    sort: true,
    filter: textFilter({
        placeholder: 'Consultar',  // custom the input placeholder
    })
}, 
{
    dataField: 'email',
    text: 'Email',
    sort: true,
    filter: textFilter({
        placeholder: 'Consultar',  // custom the input placeholder
    })
}, 
{
    text: 'Opções',
    formatter: actionsFormatter,
    style: {
        width: '20%'
    }
}
];

class Table extends React.Component {

    constructor(props) {
        super(props);

        this.options = {
            sortIndicator: true,
            noDataText: 'Sem dados'
        };

        this.selectRowProp = {
            mode: 'radio',
            bgColor: '#c1f291',
            onSelect: props.handleRowSelect,
            clickToSelect: true,
            hideSelectColumn: true
        };
    }

    render() {
        return (
            <BootstrapTable pagination={ paginationFactory() } striped hover condensed keyField='id' 
            data={this.props.agricultorObject.results ? this.props.agricultorObject.results : []} columns={columns} filter={filterFactory()} >
            
                {/* <TableHeaderColumn dataField="id" isKey hidden>Id</TableHeaderColumn>

                <TableHeaderColumn
                    dataField="nome"
                    dataSort={true}
                    caretRender={getCaret}
                    //filter={{type: 'TextFilter', delay: 0 }}
                    columnTitle
                    dataFormat={nomeFormatter}
                >
                    Nome
                </TableHeaderColumn>

                <TableHeaderColumn
                    dataField="telefone"
                    dataSort={true}
                    caretRender={getCaret}
                    //filter={{type: 'TextFilter', delay: 0 }}
                    columnTitle
                >
                    Telefone
                </TableHeaderColumn>

                <TableHeaderColumn
                    dataField="email"
                    dataSort={true}
                    caretRender={getCaret}
                    //filter={{type: 'TextFilter', delay: 0 }}
                    columnTitle
                >
                    Email
                </TableHeaderColumn>

                <TableHeaderColumn
                    dataFormat={actionsFormatter}
                    formatExtraData={this.props}
                    //filter={{type: 'TextFilter', delay: 0 }}
                    columnTitle
                >
                    Ações
                </TableHeaderColumn> */}
            </BootstrapTable>
        );
    }

}

Table.propTypes = {
    agricultorObject: PropTypes.array.isRequired,
    handleClickEditar: PropTypes.func.isRequired,
    handleClickDelete: PropTypes.func.isRequired,
    handleRowSelect: PropTypes.func.isRequired
};

export default Table;
